<div class="btn-group">
  <button
    mui-btn
    appearance="primary"
    icon="check"
    id="accept-cookie-settings-button"
    (click)="onAcceptRequiredCookies()">
    {{ 'cookieSettings.dialog.btn.acceptOnlyRequired' | translate }}
  </button>
  <button
    mui-btn
    #acceptAllButton
    appearance="primary"
    icon="check-double"
    id="allow-all-cookie-settings-button"
    (click)="onAcceptAllCookies()">
    {{ 'cookieSettings.dialog.btn.acceptAll' | translate }}
  </button>
</div>
